/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import { useParticipants } from '../../../../hooks/useParticipants';
import { ParticipantList } from './ParticipantList';
import { ContactList } from './ContactList';

export namespace Participants {
  export interface Props {
    roomId: string;
  }
}

export const Participants: React.FC<Participants.Props> = ({ roomId }) => {
  const { isLoading, dispatchParticipants, resetParticipants } = useParticipants(roomId);

  useEffect(() => {
    (async () => await dispatchParticipants())();
    return resetParticipants;
  }, [roomId]);

  return (
    <div data-it={'overviewTab'}>
      <ParticipantList roomId={roomId} isLoading={isLoading} />
      <ContactList roomId={roomId} isLoading={isLoading} />
    </div>
  );
};
